import React from 'react';
import getColor from '../../utils/interpolateColor';

const ReportCircleProgressChart = ({ value = 0, size = 72, strokeWidth = 8, label = '', darkMode = false, showCaption = true }) => {
  const normalizedRadius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const clamped = Math.max(0, Math.min(100, Number(value) || 0));
  const strokeDashoffset = circumference - (clamped / 100) * circumference;

  return (
    <div className="flex items-center space-x-3 py-4">
      <svg width={size} height={size}>
        <circle
          stroke={darkMode ? '#374151' : '#e5e7eb'}
          fill="transparent"
          strokeWidth={strokeWidth}
          r={normalizedRadius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          stroke={getColor(clamped)}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          r={normalizedRadius}
          cx={size / 2}
          cy={size / 2}
          style={{
            transform: 'rotate(-90deg)',
            transformOrigin: '50% 50%',
            strokeDasharray: `${circumference} ${circumference}`,
            strokeDashoffset,
            transition: 'stroke-dashoffset 0.4s ease',
          }}
        />
        <text x="50%" y="43%" dominantBaseline="central" textAnchor="middle" fontSize={size * 0.22} fontWeight={800} fill={darkMode ? '#f9fafb' : '#111827'}>
          {Math.round(clamped)}
        </text>
        {showCaption ? (
          <text x="50%" y="66%" dominantBaseline="central" textAnchor="middle" fontSize={size * 0.10} fontWeight={800} fill={darkMode ? '#e5e7eb' : '#4b5563'}>
            POÄNG
          </text>
        ) : null}
      </svg>
      {label ? (
        <span className={`text-sm font-semibold ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>{label}</span>
      ) : null}
    </div>
  );
};

export default ReportCircleProgressChart;


